function e(e,t=166){let i;function o(...o){clearTimeout(i),i=setTimeout((()=>{e.apply(this,o)}),t)}return o.clear=()=>{clearTimeout(i)},o}export{e as d};
